package com.ijoin.i18n

/**
 * Chinese (Mandarin/Putonghua) strings implementation
 */
object ChineseStrings : Strings {
    override val appName = "iJoin"
    override val clickMe = "点击我！"
    override val greetingMessage = "Compose"
    override fun helloPlatform(platformName: String) = "你好，$platformName！"
    override val language = "语言"
    override val english = "英语"
    override val russian = "俄语"
    override val changeLanguage = "更改语言"
    override val ok = "确定"
    override val cancel = "取消"
    override val save = "保存"
    override val delete = "删除"
    override val edit = "编辑"
    override val close = "关闭"
    override val retry = "重试"
    override val share = "分享"
    override val unknownErrorMessage = "出现问题，请重试。"
    override val missingEventDateError = "缺少活动日期。"
    override val slotSelectionRequired = "请选择至少一个时段。"
    override val userContextMissingError = "无法识别当前用户。"
    override val cancelSlotsSelectionRequired = "请选择至少一个要取消的时段。"
    override val cancelDaySelectionRequired = "请选择要取消的日期。"
    override val restoreSlotsSelectionRequired = "请选择至少一个要恢复的时段。"
    override val restoreDaySelectionRequired = "请选择要恢复的日期。"
    override val cancelSlotsFailed = "无法取消所选时段。"
    override val cancelDayFailed = "无法取消所选日期。"
    override val restoreSlotsFailed = "无法恢复所选时段。"
    override val restoreDayFailed = "无法恢复所选日期。"
    override val cancelEventFailed = "无法取消活动。"
    override val restoreEventFailed = "无法恢复活动。"
    override val selectedDateUnavailableError = "所选日期不可用。"
    override val selectedDateInPastError = "所选日期已过。"
    override val notSelected = "未选择"
    override fun atTime(time: String) = "于 $time"
    override val enableNotificationsTitle = "保持关注"
    override val enableNotificationsBody = "启用浏览器通知，获取新活动和聊天动态。"
    override val allowNotificationsAction = "允许通知"
    override val notNowAction = "稍后"
    override val searchPlaceholder = "搜索活动、组织者、地点..."
    override val myTickets = "我的门票"
    override val tapToViewTicket = "点击查看门票"
    override val favoriteEvents = "收藏"
    override val eventsYouSaved = "您收藏的活动"
    override val recommendedForYou = "为您推荐"
    override val curatedEvents = "根据您的兴趣精选的活动"
    override val recommendations = "推荐"
    override val upcomingEvents = "即将举行的活动"
    override val searchResults = "搜索结果"
    override val noResults = "未找到结果"
    override val noAvailableEvents = "没有可用的活动"
    override val createEvent = "创建活动"
    override val menu = "菜单"
    override val home = "首页"
    override val explore = "探索"
    override val tickets = "门票"
    override val profile = "个人资料"
    override val upcomingPaidTicketsTitle = "即将到来的付费门票"
    override val otherTicketsTitle = "其他门票"
    override val offlineTicketsNotice = "显示已保存的门票。部分信息可能已过期。"
    override val ticketsEmptyMessage = "您还没有门票。"
    override val ticketDetailsTitle = "门票详情"
    override val ticketNumberLabel = "门票号码"
    override val ticketStatusActive = "有效"
    override val ticketStatusCancelled = "已取消"
    override val ticketStatusRefunded = "已退款"
    override val ticketStatusUsed = "已使用"
    override val ticketHolderLabel = "持票人"
    override val cancelTicketAction = "取消门票"
    override val ticketCancellationConfirmTitle = "确定取消门票？"
    override val ticketCancellationConfirmMessage = "这将退还您的座位，让其他参与者可以预订。"
    override val ticketCancellationSuccess = "门票已取消"
    override val ticketCancellationFailure = "无法取消门票"
    override val ticketLoadError = "无法加载门票"
    override val refresh = "刷新"
    override val settings = "设置"
    override val createEventTitle = "创建活动"
    override val eventTitle = "活动标题"
    override val eventTitlePlaceholder = "输入活动名称"
    override val eventDescription = "描述"
    override val eventDescriptionPlaceholder = "描述您的活动..."
    override val aiGenerateDescription = "AI：生成描述"
    override val aiFormatDescription = "AI：结构化并完成描述"
    override val addMedia = "添加照片/视频"
    override val mediaChooseFile = "选择文件"
    override val location = "地点"
    override val onlineEvent = "线上活动"
    override val onlineLink = "线上链接"
    override val onlineLinkPlaceholder = "https://example.com/meeting"
    override val onlineLinkNotice = "付款后可查看链接"
    override val placeName = "地点名称"
    override val address = "地址"
    override val ticketPrice = "门票价格"
    override val ticketPricePlaceholder = "25.00"
    override val dateAndTime = "日期和时间"
    override val recurringEvent = "周期性活动"
    override val recurrenceType = "重复类型"
    override val daysOfWeek = "星期"
    override val daysOfMonth = "日期"
    override val selectDaysOfWeek = "选择星期"
    override val selectDaysOfMonth = "选择日期"
    override val time = "时间 (时:分)"
    override val hiddenInfo = "隐藏信息"
    override val hiddenInfoDescription = "购票后用户可见"
    override val hiddenInfoPlaceholder = "付款后可见的信息..."
    override val enableGroupChatLabel = "创建群聊"
    override val enableGroupChatDescription = "所有预订或购票的人将加入共享聊天。"
    override val groupChatLabel = "群聊"
    override val groupChatSubtitle = "所有参与者的聊天"
    override val carpoolSettings = "拼车设置"
    override val enableCarpool = "启用拼车"
    override val contactInfoSettings = "联系信息设置"
    override val requireContactInfo = "收集联系信息"
    override val requireContactInfoDescription = "要求客户在预订时提供电话和其他信息"
    override val freeCarpool = "免费拼车"
    override val carpoolPaymentPerPerson = "每位乘客付费"
    override fun carpoolPaymentLabel(symbol: String) = "每人付费 ($symbol)"
    override val carpoolPaymentPlaceholder = "10.00"
    override val carpoolDescription = "用户可以标明他们有车，并指定可以搭载多少乘客"
    override val carpoolPaymentHint = "设置乘客应支付的乘车费用"
    override val selectDate = "选择日期"
    override val back = "返回"
    override val create = "创建"
    override val currency = "货币"
    override val selectCurrency = "选择货币"
    override val category = "分类"
    override val selectCategory = "选择分类"
    override val tags = "标签"
    override val addTag = "添加标签"
    override val maxCapacity = "最大容量"
    override val maxCapacityPlaceholder = "50"
    override val duration = "时长"
    override val durationMinutes = "时长（分钟）"
    override fun formatDuration(minutes: Int): String {
        if (minutes <= 0) return ""
        val days = minutes / (24 * 60)
        val hours = (minutes % (24 * 60)) / 60
        val mins = minutes % 60

        return when {
            days >= 7 -> {
                val weeks = days / 7
                val remainingDays = days % 7
                if (remainingDays > 0) "${weeks}周 ${remainingDays}天"
                else "${weeks}周"
            }
            days > 0 -> {
                if (hours > 0) "${days}天 ${hours}小时"
                else "${days}天"
            }
            hours > 0 -> {
                if (mins > 0) "${hours}小时 ${mins}分钟"
                else "${hours}小时"
            }
            else -> "${mins}分钟"
        }
    }
    override val locationCountry = "国家"
    override val selectOnMap = "在地图上选择"
    override val locationSearchPlaceholder = "输入地址或场地名称"
    override val onlineLinkHidden = "付款后可见链接"
    override val timeZone = "时区"
    override fun timeZoneValue(timeZoneId: String) = "时区: $timeZoneId"
    override val selectTimeZone = "选择时区"
    override val localTimeZone = "本地时区"
    override val mediaFilesAdded = "已添加文件"
    override val free = "免费"
    override val priceForFreeEvent = "0 - 免费活动"
    override val additionalOptions = "其他选项"
    override val ageRestriction = "年龄限制"
    override val languageEvent = "活动语言"
    override val contactInfo = "联系信息"
    override val website = "网站"
    override val phone = "电话"
    override val email = "电子邮件"
    override val comment = "备注"
    override val phoneRequired = "电话是必填项"
    override val city = "城市"
    override val search = "搜索"
    override val year = "年"
    override val month = "月"
    override val day = "日"
    override fun weekdayShortName(index: Int) = listOf("周一", "周二", "周三", "周四", "周五", "周六", "周日")[index % 7]
    override fun weekdayName(index: Int) = listOf("星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日")[index % 7]
    override fun monthNameFull(month: Int) = listOf(
        "一月", "二月", "三月", "四月", "五月", "六月",
        "七月", "八月", "九月", "十月", "十一月", "十二月"
    )[(month - 1).mod(12)]
    override fun monthNameGenitive(month: Int) = monthNameFull(month)
    override val createEventWizard = "创建活动"
    override val step = "步骤"
    override val of = "/"
    override val next = "下一步"
    override val previous = "上一步"
    override val saveDraft = "保存草稿"
    override val editEvent = "编辑活动"
    override val step1BasicInfo = "基本信息"
    override val step2Schedule = "时间安排"
    override val scheduleTypeLabel = "时间类型"
    override val scheduleOneTimeDescription = "选定日期的单次活动"
    override val scheduleWeeklyDescription = "在选定的工作日重复"
    override val scheduleSlotDescription = "可预订时段的日历"
    override val scheduleOneTimeSetup = "单次活动设置"
    override val schedulePreviewTitle = "预览"
    override fun schedulePreviewDate(date: String) = "日期: $date"
    override fun schedulePreviewTime(start: String, end: String) = "时间: $start - $end"
    override val step3Location = "地点"
    override val eventSetupTitle = "活动设置"
    override val eventTypeLabel = "活动类型"
    override val oneTimeEvent = "单次活动"
    override val eventSeries = "系列活动"
    override val weekly = "每周"
    override val monthly = "每月"
    override val slotBooking = "时段预订"
    override val slotLabel = "时段"
    override val slotsLabel = "时段"
    override val selectDayOfWeek = "选择星期"
    override val selectDayOfMonth = "选择日期"
    override val availableTimeRange = "可用时间范围"
    override val startTime = "开始时间"
    override val endTime = "结束时间"
    override val endDateLabel = "结束日期（可选）"
    override val invalidEndDate = "结束日期必须在开始日期当天或之后"
    override val invalidEndTime = "结束时间必须在开始时间之后"
    override val eventDateMustBeFuture = "活动日期必须在未来"
    override val eventTimeMustBeFuture = "活动时间必须在当前时间之后"
    override val slotSettings = "时段设置"
    override val minSlots = "最少时段"
    override val minSlotsPlaceholder = "1"
    override val slotDuration = "时长（分钟）"
    override val slotDurationPlaceholder = "30"
    override val perDayTimeConfiguration = "每天可用时间"
    override val driverCompensation = "司机补偿"
    override val fixedAmountPerPassenger = "每位乘客固定金额"
    override val coordinateRide = "协调行程"
    override val participantsWithCar = "有车参与者"
    override val needRide = "需要搭车"
    override val draft = "草稿"
    override val saved = "已保存"
    override val eventSaveErrorTitle = "无法保存活动"
    override val eventSaveErrorMessage = "保存活动时出错，请重试。"
    override val deleteEventTitle = "删除活动？"
    override val deleteEventMessage = "此操作无法撤销。是否继续？"
    override val eventDeletedMessage = "活动已删除"
    override val organizerLabel = "组织者"
    override val online = "线上"
    override val offline = "线下"
    override val eventDetailsTitle = "活动详情"
    override val addToFavorites = "添加到收藏"
    override val removeFromFavorites = "从收藏中移除"
    override val ticketTierStandard = "标准"
    override fun ticketsAvailable(count: Int) = "剩余 $count 张票"
    override val viewTicket = "查看门票"
    override val bookingRequestFailed = "预订失败"
    override val contactSendFailed = "提交联系信息失败"
    override val unexpectedReservation = "免费活动的意外预订"
    override val sampleReviewerName = "张三"
    override val sampleReviewTimeAgo = "2天前"
    override val selectVisitDate = "选择参观日期"
    override fun availableDaysLabel(days: String) = "可用日期: $days"
    override val previousMonth = "上个月"
    override val nextMonth = "下个月"
    override fun slotSelectionMessage(date: String, time: String?) =
        if (time.isNullOrBlank()) "您选择了: $date" else "您选择了: $date $time"
    override fun eventImageContentDescription(title: String, index: Int) = "$title - 图片 $index"
    override val dateTbd = "待定"
    override val recurringWeeklyDescription = "此活动在选定的日期每周举行。"
    override val recurringMonthlyDescription = "此活动在选定的工作日每月举行。"
    override val userCardTitle = "组织者资料"
    override val followAction = "关注"
    override val followingAction = "已关注"
    override val followersCountLabel = "粉丝"
    override val followingCountLabel = "关注"
    override val eventsCountLabel = "活动"
    override val organizerEventsTitle = "即将举行的活动"
    override val archiveSectionTitle = "历史记录"
    override val aboutOrganizerTitle = "关于组织者"
    override val userEventsEmpty = "该组织者暂无即将举行的活动。"
    override val userArchiveEmpty = "没有历史活动。"
    override val addShortcutTitle = "添加快捷方式？"
    override fun addShortcutMessage(displayName: String) =
        "将 $displayName 添加到主屏幕以快速访问其活动？"
    override val addShortcutConfirm = "添加快捷方式"
    override val addShortcutDismiss = "稍后"
    override val dateLabel = "日期"
    override val participants = "参与者"
    override val spotsLeft = "剩余名额"
    override val ticketQuantityLabel = "门票数量"
    override val increaseQuantity = "增加数量"
    override val decreaseQuantity = "减少数量"
    override val costLabel = "参与费用"
    override val serviceFee = "服务费"
    override val totalAmount = "总计"
    override fun serviceFeePercent(percent: Int) = "服务费 ($percent%)"
    override val dressCode = "着装要求"
    override val dressCodePlaceholder = "正装"
    override val description = "描述"
    override val reviews = "评价"
    override val allReviews = "所有评价"
    override val contactOrganizer = "联系组织者"
    override val slotBookingsTitle = "时段预订"
    override val slotBookingsEmptyMessage = "暂无预订时段。"
    override val showAllBookings = "全部"
    override val showToday = "今天"
    override val showThisMonth = "本月"
    override val showSelectedDate = "选定日期"
    override val noBookingsForSelectedDate = "该日期暂无预订。"
    override val noTicketsForSelectedDate = "该日期暂无门票。"
    override fun totalCount(count: Int) = "总计: $count"
    override val cancelEventAction = "取消活动"
    override val cancelEventDescription = "停止售票并将活动标记为已取消。"
    override val organizerActionsTitle = "组织者工具"
    override val eventAlreadyCancelledNotice = "活动已取消。"
    override val eventCancelledTitle = "活动已取消"
    override val eventCancelledSubtitle = "组织者已取消此活动。无法再预订。"
    override val cancellationReasonLabel = "取消原因"
    override val cancellationReasonPlaceholder = "描述取消原因"
    override val cancellationReasonRequired = "请提供简短的原因。"
    override val cancelSelectedSlotsAction = "取消所选时段"
    override val cancelSelectedSlotsDescription = "参与者将无法预订所选时段。"
    override val cancelSlotDayAction = "取消所选日期"
    override val cancelSlotDayDescription = "所选日期的所有时段将被阻止。"
    override val selectedSlotsLabel = "所选时段"
    override val selectedDayLabel = "所选日期"
    override val restoreEventAction = "恢复活动"
    override val restoreEventDescription = "取消后重新开放活动。"
    override val restoreSelectedSlotsAction = "恢复所选时段"
    override val restoreSelectedSlotsDescription = "允许参与者再次预订所选时段。"
    override val restoreSlotDayAction = "恢复所选日期"
    override val restoreSlotDayDescription = "重新开放所选日期的所有时段。"
    override val bookingStatusPending = "待处理"
    override val bookingStatusConfirmed = "已确认"
    override val bookingStatusCancelled = "已取消"
    override val bookingStatusCompleted = "已预订"
    override val bookingStatusNoShow = "未到场"
    override val viewDetails = "查看详情"
    override val hideDetails = "隐藏详情"
    override val openChat = "打开聊天"
    override val clientNotesLabel = "客户备注"
    override val bookingDetailsTitle = "预订详情"
    override val slotBookedByLabel = "预订者"
    override val slotAvailableLabel = "可用"
    override val statusLabel = "状态"
    override val connectTitle = "直接收款"
    override val connectStatusActive = "已激活"
    override val connectStatusPending = "待处理"
    override val connectStatusPlatform = "平台"
    override val connectStatusUnderReview = "审核中"
    override val connectStatusSetupNeeded = "需要设置"
    override val connectEnableDirectAction = "启用直接收款"
    override val connectContinueOnboarding = "继续设置"
    override val connectOpenDashboard = "打开 Stripe 控制台"
    override val connectSwitchToPlatform = "切换到平台收款"
    override val connectPlatformFeeLabel = "平台手续费"
    override val connectDirectPaymentsEnabled = "已启用直接收款"
    override val connectSwitchedToPlatform = "已切换为平台收款"
    override val connectOnboardingDescription = "设置您的 Stripe 账户以直接接收付款"
    override val connectActiveDescription = "付款将直接进入您的 Stripe 账户"
    override val connectPlatformDescription = "付款通过平台进行处理"
    override val connectUnderReviewDescription = "您的账户正在接受 Stripe 的审核"
    override fun connectPlatformFeeValue(percent: Int) = "$percent%"

    override val billingTitle = "账单"
    override val currentBalanceLabel = "当前余额"
    override val openBillingAction = "账单和提现"
    override val withdrawFundsAction = "提现"
    override val pendingPayoutsLabel = "待处理提现"
    override val withdrawnTotalLabel = "已提现"
    override val billingFilterWeek = "7天"
    override val billingFilterMonth = "30天"
    override val billingFilterQuarter = "90天"
    override val grossSalesLabel = "总销售额"
    override val feesLabel = "手续费"
    override val netRevenueLabel = "净收入"
    override val payoutRequestsTitle = "提现请求"
    override val payoutRequestsEmpty = "暂无提现请求"
    override val payoutStatusPending = "待处理"
    override val payoutStatusProcessing = "处理中"
    override val payoutStatusPaid = "已支付"
    override val payoutStatusRejected = "已拒绝"
    override val requisitesTitle = "提现详情"
    override val requisitesAccountLabel = "账号"
    override val requisitesInnLabel = "INN"
    override val requisitesKppLabel = "KPP"
    override val requisitesBikLabel = "BIC"
    override val bankLabel = "银行"
    override val soldTicketsTitle = "已售门票"
    override val soldTicketsEmpty = "此期间无门票销售"
    override val withdrawConfirmTitle = "确认提现？"
    override fun withdrawConfirmMessage(amount: String) = "您即将请求提现 $amount。"
    override val billingWithdrawSuccess = "提现请求已提交"
    override val billingWithdrawFailed = "无法提交提现请求"
    override val billingWithdrawUnavailable = "没有可提现的余额"
    override val payoutMethodEtransfer = "eTransfer（加拿大）"
    override val payoutMethodWise = "Wise转账"
    override val payoutDetailsTitle = "提现详情"
    override val payoutEmailLabel = "收款人邮箱"
    override val payoutWiseNameLabel = "账户持有人姓名"
    override val payoutWiseAccountLabel = "账号 / IBAN"
    override val payoutWiseBankLabel = "银行名称或SWIFT"
    override val payoutWiseRoutingLabel = "路由号码"
    override val payoutWiseAccountTypeLabel = "账户类型"
    override val payoutAccountTypeChecking = "支票账户"
    override val payoutAccountTypeSavings = "储蓄账户"
    override val payoutNoteLabel = "提现备注（可选）"
    override fun soldTicketQuantity(quantity: Int, grossAmount: String) = "$quantity x $grossAmount"
    override fun soldTicketBuyerInfo(buyerName: String, soldAt: String) = "$buyerName - $soldAt"
    override fun soldTicketServiceFee(fee: String) = "- $fee"
    override fun shortMonthName(month: Int): String = when (month) {
        1 -> "1月"; 2 -> "2月"; 3 -> "3月"; 4 -> "4月"; 5 -> "5月"; 6 -> "6月"
        7 -> "7月"; 8 -> "8月"; 9 -> "9月"; 10 -> "10月"; 11 -> "11月"; 12 -> "12月"
        else -> ""
    }
    override val accountDetails = "账户详情"
    override val interfaceLanguage = "界面语言"
    override val profileSavedMessage = "资料已更新"
    override val profileLogoutDescription = "在此设备上退出 iJoin。"
    override val profileLoadError = "无法加载资料"
    override val logoutError = "退出失败，请重试。"
    override val messagesTitle = "消息"
    override val emptyChatList = "暂无对话"
    override val emptyMessages = "暂无消息。开始对话吧！"
    override val typeMessage = "消息..."
    override val send = "发送"
    override val chatSearchPlaceholder = "按名称搜索用户"
    override val chatSearchNoResults = "未找到用户"
    override val chatLoadError = "无法加载聊天消息"
    override val chatSendError = "无法发送消息"
    override val chatOpenError = "无法打开聊天"
    override val chatStartError = "无法开始聊天"
    override val chatSearchError = "目前无法搜索用户"
    override val paymentTitle = "预订付款"
    override val paymentSubtitle = "完成预订付款"
    override val paymentDescription = "付款成功后，您的预订将自动更新。"
    override val paymentPreparing = "准备 Stripe 结账..."
    override val paymentFetchingTickets = "获取您的门票..."
    override val paymentCompletedMessage = "付款已确认。如果门票未自动显示，请刷新下方列表。"
    override val paymentStripePopupHint = "Stripe 在弹出窗口中打开。如果未出现或您已关闭它，请点击\"重新支付\"。"
    override val paymentRetryButton = "重新支付"
    override val paymentRetryTicketsButton = "重新获取门票"
    override val paymentStartFailed = "无法开始付款"
    override val paymentTicketContextMissing = "无法确定出票的预订"
    override val paymentTicketsNotFound = "未找到门票"
    override val paymentTicketsFetchFailed = "无法获取门票"
    override val errorUserNotAuthenticated = "请登录以继续。"
    override val errorAccessDenied = "您没有权限执行此操作。"
    override val errorForbiddenFollowingList = "您只能查看自己的关注列表。"
    override val errorDataUrlRequired = "需要图片数据（dataUrl）。"
    override val errorMediaStoreFailed = "存储媒体失败，请重试。"
    override val errorAmountMustBePositive = "金额必须大于零。"
    override val errorAmountExceedsBalance = "请求金额超过可用余额。"
    override val errorPayoutEmailRequired = "eTransfer 提现需要电子邮件。"
    override val errorPayoutWiseInfoRequired = "Wise 提现需要全名、路由号码和账号。"
    override val errorPayoutAccountType = "不支持的账户类型。请使用支票或储蓄账户。"
    override val errorUnsupportedPayoutMethod = "不支持的提现方式。"
    override val errorEventNotCancelled = "活动未取消。"
    override val errorChatWithSelf = "您不能与自己聊天。"
    override val errorChatMessageEmpty = "消息不能为空。"
    override val errorEventOrganizerRequired = "需要活动 ID 和组织者。"
    override val errorEventUnavailable = "活动不再可用。"
    override val errorEventFinished = "活动已结束。"
    override val errorOrganizerNotProvider = "组织者不是服务提供商。"
    override val errorServiceProviderInactive = "服务提供商未激活。"
    override val errorSlotsNotFound = "未找到某些时段。"
    override val errorSlotsMustSameEvent = "所有时段必须属于同一活动。"
    override val errorSlotsMustSameOrganizer = "所有时段必须属于活动的组织者。"
    override val errorSlotsUnavailable = "一个或多个时段不可用。"
    override val errorSlotsInPast = "无法预订已过去的时段。"
    override val errorSlotsMustBeConsecutive = "时段必须是连续的。"
    override val errorEventIdRequired = "需要活动 ID。"
    override val errorQuantityAtLeastOne = "数量必须至少为 1。"
    override val errorPaidReservationRequired = "此活动需要付费预订。"
    override val errorEventOrganizerInvalid = "活动组织者无效。"
    override val errorEventOrganizerMissing = "未设置活动组织者。"
    override val errorOrganizerCannotAccept = "组织者无法接受预订。"
    override val errorOccurrenceRequired = "需要活动日期。"
    override val errorOccurrencePassed = "所选场次已过。"
    override val errorTicketsNotEnough = "此活动门票不足。"
    override val errorBookingOtherUser = "预订属于其他用户。"
    override val errorBookingNotAwaitingPayment = "预订不在等待付款状态。"
    override val errorBookingCancelled = "预订已取消。"
    override val errorBookingNotActive = "预订不再有效。"
    override val errorBookingIssuedTickets = "预订已出票。"
    override val errorEventRequiresPaymentFlow = "此活动需要付款。完成结账以完成预订。"
    override val errorReservationQuantityExceeded = "请求数量超过预订量。"
    override val errorTicketAlreadyValidated = "门票已验证。"
    override val errorTicketInactive = "门票无效。"
    override val errorTicketAlreadyCancelled = "门票已取消。"
    override val errorTicketUsed = "已使用的门票无法取消。"
    override val errorOccurrencesRequired = "需要场次。"
    override val errorRequestRequired = "需要请求数据。"
    override val errorBookingEventMismatch = "预订不属于提供的活动。"
    override val errorBookingProcessed = "预订已处理。"
    override val errorOverrideAmountAdminOnly = "只有管理员才能覆盖金额。"
    override val errorOverrideAmountPositive = "覆盖金额必须为正数。"
    override val errorUnableDetermineTicketPrice = "无法确定门票价格。"
    override val errorEmailAlreadyRegistered = "电子邮件已注册。"
    override val errorInvalidCredentials = "电子邮件或密码无效。"
    override val errorAccountInactive = "账户未激活。"
    override val errorInvalidRefreshToken = "无效的刷新令牌。"
    override val errorAvatarDataUrlRequired = "头像数据必须以 data URL 格式提供。"
    override val errorAvatarMustBeImage = "头像必须是图片。"
    override val errorAvatarInvalidDataUrl = "头像 data URL 无效。"
    override val errorStripeSignatureInvalid = "无效的 Stripe 签名。"
    override val errorMediaUnsupportedFormat = "不支持的图片格式。"
    override val errorReservationExpired = "预订已过期。请重新预订。"
    override val login = "登录"
    override val register = "注册"
    override val continueWithGoogle = "使用 Google 继续"
    override val continueWithApple = "使用 Apple 继续"
    override val logout = "退出"
    override val password = "密码"
    override val username = "用户名"
    override val firstName = "名"
    override val lastName = "姓"
    override val confirmPassword = "确认密码"
    override val alreadyHaveAccount = "已有账户？"
    override val dontHaveAccount = "没有账户？"
    override val loginHere = "在此登录"
    override val registerHere = "在此注册"
    override val welcomeBack = "欢迎回来！"
    override val createAccount = "创建账户"
    override val loginError = "登录失败，请检查您的凭据。"
    override val registerError = "注册失败，请重试。"
    override val passwordsDontMatch = "密码不匹配"
    override val fillAllFields = "请填写所有必填字段"
    override val invalidEmail = "请输入有效的电子邮件地址"
    override val forgotPassword = "忘记密码？"
    override val passwordResetTitle = "重置密码"
    override val passwordResetDescription = "输入您的电子邮件地址以接收重置说明。"
    override val passwordResetSetNewPassword = "设置新密码"
    override val sendResetLink = "发送重置链接"
    override fun passwordResetEmailSent(email: String) = "如果 $email 存在账户，我们已发送重置链接。"
    override val passwordResetTokenLabel = "重置令牌"
    override val passwordResetTokenDescription = "粘贴电子邮件中的代码或在此设备上打开链接。"
    override val newPassword = "新密码"
    override val resetPasswordAction = "更新密码"
    override val passwordResetSuccess = "密码已更新！您可以使用新密码登录。"
    override val backToLogin = "返回登录"
    override val profileDeletedMessage = "账户已删除"
    override val deleteAccountTitle = "删除账户"
    override val deleteAccountDescription = "这将停用您的账户、匿名化个人数据，并将您的活动从搜索中移除。"
    override val deleteAccountAction = "删除账户"
    override val deleteAccountConfirmMessage = "您确定吗？请在删除前通过提款请求提取任何剩余余额。"
    override val aiConsentSectionTitle = "AI 数据处理"
    override val aiConsentEnabled = "您已同意为语音转写和描述生成等可选功能与 AI 服务（OpenAI、Google）共享数据。"
    override val aiConsentDisabled = "AI 数据处理同意未启用。AI 功能不可用。"
    override val aiConsentWithdrawButton = "撤回同意"
    override val aiConsentEnableButton = "启用 AI 功能"
    override val aiConsentWithdrawConfirmTitle = "撤回 AI 同意？"
    override val aiConsentWithdrawConfirmMessage = "AI 功能（转写、描述生成、落地页）将不可用。您可随时重新启用。"
    override val aiConsentWithdrawnSuccess = "已撤回 AI 数据处理同意"
    override val aiConsentEnabledSuccess = "已授予 AI 数据处理同意"
    override val errorAccountDeleted = "账户已被删除。"
    override val errorAccountBalanceNotZero = "请在删除账户前提取剩余余额。"

    override val invalidPhone = "请输入有效的电话号码"
    override val provideAnyContact = "输入电话或电子邮件"
    override val checkContacts = "请检查联系方式格式"
    override val contactSubmitting = "保存中..."
    override val contactSubmitted = "请求已发送"
    override val book = "预订"
    override val bookFree = "免费预订"
    override val bookingSuccess = "预订成功！"
    override val bookingFailed = "预订失败"
    override fun bookForPrice(price: String) = "以 $price 预订"
    override val prev = "上一页"
    override val showAll = "显示全部"
    override val collapse = "收起"
    override val missingTitle = "输入活动标题"
    override val missingDescription = "输入活动描述"
    override val missingScheduleType = "选择时间类型"
    override val missingDate = "选择活动日期"
    override val missingTime = "选择活动时间"
    override val missingWeeklyDays = "选择一个或多个工作日"
    override val missingWeeklyTime = "选择每周活动的时间"
    override val missingSlotDays = "选择时段的星期"
    override val missingSlotStart = "选择时段开始时间"
    override val missingSlotEnd = "选择时段结束时间"
    override val missingLocation = "请指定活动地点"
    override val optional = "可选"
    override val bookingsTitle = "预订"
    override val unconfirmedRequestsTitle = "待确认请求"
    override val detailsButton = "详情"
    override val hideDetailsBooking = "隐藏"
    override val noBookings = "暂无预订"
    override val noUnconfirmedRequests = "没有待确认的请求"
    override val ticketInfoLabel = "门票"
    override val contactInfoLabel = "联系信息"
    override val paymentInfoLabel = "付款"
    override val loadingPayment = "加载中..."
    override val clientLabel = "客户"
    override val paymentAmount = "金额"
    override val paymentStatus = "状态"
    override val paymentDate = "日期"
    override val appStoreBannerTitle = "获取应用"
    override val appStoreBannerMessage = "下载我们的应用以获得最佳体验"
    override val downloadOnAppStore = "在 App Store 下载"
    override val getItOnGooglePlay = "在 Google Play 下载"
    override val downloadAppLinks = "下载我们的应用"
    override val updateAvailable = "有可用更新"
    override val updateRequired = "需要更新"
    override val updateAvailableMessage = "iJoin 有新版本可用。立即更新以获取最新功能和改进。"
    override val updateRequiredMessage = "请更新 iJoin 以继续使用该应用。此版本不再受支持。"
    override val updateNow = "立即更新"
    override val updateLater = "稍后"
    override val newVersion = "新版本"
    override val currentVersion = "当前版本"
    override val whatsNew = "新功能"
    override val landingModeClassic = "经典"
    override val landingModeAi = "AI 着陆页"
    override val landingModeTitle = "着陆页类型"
    override val landingDescriptionLabel = "着陆页描述"
    override val landingDescriptionPlaceholder = "描述您的活动，让 AI 生成精美的着陆页..."
    override val recordVoice = "录音"
    override val stopRecording = "停止录音"
    override val transcribing = "转录中..."
    override val recordingTooShort = "录音太短（最少 3 秒）"
    override val recordingTooLong = "录音太长（最多 5 分钟）"
    override val microphoneAccessDenied = "麦克风访问被拒绝"
    override fun recordingDuration(seconds: Int) = "${seconds}秒"
    override val enableLandingPageLabel = "使用着陆页"
    override val enableLandingPageDescription = ""
    override val termsOfService = "服务条款"
    override val privacyPolicy = "隐私政策"
    override val refundPolicy = "退款和取消政策"
    override val organizerTerms = "组织者条款"
    override val aiDataConsent = "AI数据处理同意书"
    override val aiConsentTitle = "AI功能使用第三方服务"
    override val aiConsentDescription = "本应用的部分功能使用OpenAI和Google提供的人工智能服务。使用这些功能时，您提供的部分内容将被发送到这些服务进行处理。"
    override val aiConsentDataSent = "可能发送的数据："
    override val aiConsentDataSentAudio = "录音（用于语音转文字）"
    override val aiConsentDataSentDescription = "活动描述（用于文本优化）"
    override val aiConsentDataSentLanding = "落地页详情（用于内容生成）"
    override val aiConsentProviders = "数据由OpenAI（OpenAI, L.L.C.）和Google（Google LLC）处理。您的个人账户数据（姓名、邮箱）不会被发送，除非它是您提交内容的一部分。请查看完整文档了解详情。"
    override val aiConsentOptional = "AI功能是可选的。您可以不使用它们继续使用应用。"
    override val aiConsentAccept = "我同意"
    override val aiConsentDecline = "暂不同意"
    override val iAgreeToThe = "我同意以下内容："
    override val iAgreeToTerms = "我同意服务条款、隐私政策和退款政策"
    override val iAgreeToOrganizerTerms = "我同意组织者条款"
    override val pleaseAcceptTerms = "请接受条款以继续"
    override val pleaseAcceptOrganizerTerms = "请接受组织者条款以发布活动"
    override val viewDocument = "查看"
    override val legalDocumentLoading = "加载文档中..."
    override val legalDocumentLoadError = "加载文档失败"
    override val newUserGoogleNote = "如果您是新用户，请在使用 Google 登录前接受条款："
    override val legalDocumentsUpdated = "条款已更新"
    override val legalDocumentsUpdatedDescription = "我们更新了条款。请查看并接受更新的文档以继续使用应用。"
    override val iAcceptUpdatedTerms = "我接受更新的条款"
    override val continueButton = "继续"
    override val deleteEventFailed = "无法删除该活动。"
    override val mediaDesktopLabel = "用于桌面端（宽屏）"
    override val mediaMobileLabel = "用于移动端（方形）"
    override val slotLoadFailed = "无法加载时间段"
    override val slotBookingFailed = "无法预订时间段"
    override val ticketIssuanceFailed = "无法发放门票"
    override val unpublishedBookingNotice = "该活动发布后即可开始预订。"
    override val paymentStripeOverlayTitle = "Stripe 支付"
    override val paymentStripeOverlayDescription = "请输入您的银行卡信息以完成预订。"
    override val paymentStripeOverlayPayButton = "立即支付"
    override val paymentStripeOverlayPayButtonLoading = "处理中..."
    override val paymentStripeOverlayCancelButton = "取消"
    override val paymentStripeOverlayOpenError = "无法打开 Stripe 结账页面。"
    override val paymentStripeOverlayCancelMessage = "支付已取消"
    override val paymentStripeOverlayInitError = "无法初始化 Stripe。"
    override val paymentStripeOverlayPaymentFailed = "支付失败"
    override val paymentStripeOverlayUnexpectedStatusPrefix = "意外状态："
    override val paymentStripeOverlayProcessingFailed = "支付处理失败"
    override val appStoreUnavailableMessage = "抱歉，应用正在发布到商店，很快即可使用。"


}
